import Vue from "vue";
import Router from "vue-router";
import VueCookies from "vue-cookies";
import store from "./store"; //* Mecanismo de rotas

const AcessoNegado = () => import(/* webpackChunkName: "core" */ "./AcessoNegado.vue");
const Dashboard = () => import(/* webpackChunkName: "core" */ "./views/Dashboard.vue");
const Login = () => import(/* webpackChunkName: "core" */ "./views/Login.vue");

//* Rotas do Módulo Administrativo
//================================
const DeskTopADM = () => import(/* webpackChunkName: "adm" */ "./views/adm/Desktop.vue");

const Paises = () => import(/* webpackChunkName: "adm" */ "./views/adm/Paises.vue");
const Pais = () => import(/* webpackChunkName: "adm" */ "./views/adm/Pais.vue");

const UFs = () => import(/* webpackChunkName: "adm" */ "./views/adm/UFs.vue");
const UF = () => import(/* webpackChunkName: "adm" */ "./views/adm/UF.vue");

const Municipios = () => import(/* webpackChunkName: "adm" */ "./views/adm/Municipios.vue");
const Municipio = () => import(/* webpackChunkName: "adm" */ "./views/adm/Municipio.vue");

const Redes = () => import(/* webpackChunkName: "adm" */ "./views/adm/Redes.vue");
const Rede = () => import(/* webpackChunkName: "adm" */ "./views/adm/Rede.vue");

const Grupos = () => import(/* webpackChunkName: "adm" */ "./views/adm/Grupos.vue");
const Grupo = () => import(/* webpackChunkName: "adm" */ "./views/adm/Grupo.vue");

const Sites = () => import(/* webpackChunkName: "adm" */ "./views/adm/Sites.vue");
const Site = () => import(/* webpackChunkName: "adm" */ "./views/adm/Site.vue");

const Perfis = () => import(/* webpackChunkName: "adm" */ "./views/adm/Perfis.vue");
const Perfil = () => import(/* webpackChunkName: "adm" */ "./views/adm/Perfil.vue");

const Usuarios = () => import(/* webpackChunkName: "adm" */ "./views/adm/Usuarios.vue");
const Usuario = () => import(/* webpackChunkName: "adm" */ "./views/adm/Usuario.vue");

const TiposLogradouro = () => import(/* webpackChunkName: "adm" */ "./views/adm/TiposLogradouro.vue");
const TipoLogradouro = () => import(/* webpackChunkName: "adm" */ "./views/adm/TipoLogradouro.vue");

const CEPs = () => import(/* webpackChunkName: "adm" */ "./views/adm/CEPs.vue");
const CEP = () => import(/* webpackChunkName: "adm" */ "./views/adm/CEP.vue");

const AcervoCEPs = () => import(/* webpackChunkName: "adm" */ "./views/adm/AcervoCEPs.vue");
//const AcervoCEP = () => import(/* webpackChunkName: "adm" */ "./views/adm/AcervoCEP.vue");

const ConfigsEmails = () => import(/* webpackChunkName: "adm" */ "./views/adm/ConfigsEmails.vue");
const ConfigEmail = () => import(/* webpackChunkName: "adm" */ "./views/adm/ConfigEmail.vue");

const Feriados = () => import(/* webpackChunkName: "adm" */ "./views/adm/Feriados.vue");
const Feriado = () => import(/* webpackChunkName: "adm" */ "./views/adm/Feriado.vue");

const FormasPagamento = () => import(/* webpackChunkName: "adm" */ "./views/adm/FormasPagamento.vue");
const FormaPagamento = () => import(/* webpackChunkName: "adm" */ "./views/adm/FormaPagamento.vue");

const MotivosContato = () => import(/* webpackChunkName: "adm" */ "./views/adm/MotivosContato.vue");
const MotivoContato = () => import(/* webpackChunkName: "adm" */ "./views/adm/MotivoContato.vue");

const RamosAtividade = () => import(/* webpackChunkName: "adm" */ "./views/adm/RamosAtividade.vue");
const RamoAtividade = () => import(/* webpackChunkName: "adm" */ "./views/adm/RamoAtividade.vue");

const Programacoes = () => import(/* webpackChunkName: "adm" */ "./views/adm/Programacoes.vue");
const Programacao = () => import(/* webpackChunkName: "adm" */ "./views/adm/Programacao.vue");

const Clientes = () => import(/* webpackChunkName: "adm" */ "./views/adm/Clientes.vue"); //fica no módulo administrativo pois é comum a todos os módulos
const Cliente = () => import(/* webpackChunkName: "adm" */ "./views/adm/Cliente.vue"); //fica no módulo administrativo pois é comum a todos os módulos

const AcervoClientes = () => import(/* webpackChunkName: "adm" */ "./views/adm/AcervoClientes.vue");
// const AcervoCliente = () => import(/* webpackChunkName: "adm" */ "./views/adm/AcervoCliente.vue");

const Mensagens = () => import(/* webpackChunkName: "adm" */ "./views/adm/Mensagens.vue");

//* Rotas do Módulo Comercial
//============================
const DeskTopCOM = () => import(/* webpackChunkName: "com" */ "./views/com/Desktop.vue");

const Anuncios = () => import(/* webpackChunkName: "com" */ "./views/com/Anuncios.vue");
const Anuncio = () => import(/* webpackChunkName: "com" */ "./views/com/Anuncio.vue");

const Pacotes = () => import(/* webpackChunkName: "com" */ "./views/com/Pacotes.vue");
const Pacote = () => import(/* webpackChunkName: "com" */ "./views/com/Pacote.vue");

const ProdutosComercial = () => import(/* webpackChunkName: "com" */ "./views/com/Produtos.vue");
const ProdutoComercial = () => import(/* webpackChunkName: "com" */ "./views/com/Produto.vue");

const Cadernos = () => import(/* webpackChunkName: "com" */ "./views/com/Cadernos.vue");
const Caderno = () => import(/* webpackChunkName: "com" */ "./views/com/Caderno.vue");

const CondicoesEspeciais = () => import(/* webpackChunkName: "com" */ "./views/com/CondicoesEspeciais.vue");
const CondicaoEspecial = () => import(/* webpackChunkName: "com" */ "./views/com/CondicaoEspecial.vue");

const Categorias = () => import(/* webpackChunkName: "com" */ "./views/com/Categorias.vue");
const Categoria = () => import(/* webpackChunkName: "com" */ "./views/com/Categoria.vue");

const ComOrigens = () => import(/* webpackChunkName: "com" */ "./views/com/Origens.vue");
const ComOrigem = () => import(/* webpackChunkName: "com" */ "./views/com/Origem.vue");

const Formatos = () => import(/* webpackChunkName: "com" */ "./views/com/Formatos.vue");
const Formato = () => import(/* webpackChunkName: "com" */ "./views/com/Formato.vue");

const Determinacoes = () => import(/* webpackChunkName: "com" */ "./views/com/Determinacoes.vue");
const Determinacao = () => import(/* webpackChunkName: "com" */ "./views/com/Determinacao.vue");

const Colocacoes = () => import(/* webpackChunkName: "com" */ "./views/com/Colocacoes.vue");
const Colocacao = () => import(/* webpackChunkName: "com" */ "./views/com/Colocacao.vue");

const Secoes = () => import(/* webpackChunkName: "com" */ "./views/com/Secoes.vue");
const Secao = () => import(/* webpackChunkName: "com" */ "./views/com/Secao.vue");

const TabelasPreco = () => import(/* webpackChunkName: "com" */ "./views/com/TabelasPreco.vue");
const TabelaPreco = () => import(/* webpackChunkName: "com" */ "./views/com/TabelaPreco.vue");

const Textos = () => import(/* webpackChunkName: "com" */ "./views/com/Textos.vue");
const Texto = () => import(/* webpackChunkName: "com" */ "./views/com/Texto.vue");

// const Diagramas = () => import(/* webpackChunkName: "com" */ "./views/com/Diagramas.vue");
// const Diagrama = () => import(/* webpackChunkName: "com" */ "./views/com/Diagrama.vue");

//* Rotas do Módulo Assinaturas
//=============================
const DeskTopASS = () => import(/* webpackChunkName: "ass" */ "./views/ass/Desktop.vue");

const Assinaturas = () => import(/* webpackChunkName: "ass" */ "./views/ass/Assinaturas.vue");
const AssinaturaEdicao = () => import(/* webpackChunkName: "ass" */ "./views/ass/AssinaturaEdicao.vue");
const AssinaturaCaptacao = () => import(/* webpackChunkName: "ass" */ "./views/ass/AssinaturaCaptacao.vue");

const RoteiroOrdem = () => import(/* webpackChunkName: "ass" */ "./views/ass/RoteiroOrdem.vue");
const RoteiroEntrega = () => import(/* webpackChunkName: "ass" */ "./views/ass/RoteiroEntrega.vue");
const HistoricoRoteiro = () => import(/* webpackChunkName: "ass" */ "./views/ass/HistoricoRoteiro.vue");

const EtapasCobranca = () => import(/* webpackChunkName: "ass" */ "./views/ass/EtapasCobranca.vue");
const EtapaCobrancaGrupo = () => import(/* webpackChunkName: "ass" */ "./views/ass/EtapaCobrancaGrupo.vue");
const EtapaCobranca = () => import(/* webpackChunkName: "ass" */ "./views/ass/EtapaCobranca.vue");

const ClubeAssinante = () => import(/* webpackChunkName: "ass" */ "./views/ass/ClubeAssinante.vue");

const CuponsPromocoes = () => import(/* webpackChunkName: "ass" */ "./views/ass/CuponsPromocoes.vue");

const Modalidades = () => import(/* webpackChunkName: "ass" */ "./views/ass/Modalidades.vue");
const Modalidade = () => import(/* webpackChunkName: "ass" */ "./views/ass/Modalidade.vue");

const ModosEntrega = () => import(/* webpackChunkName: "ass" */ "./views/ass/ModosEntrega.vue");
const ModoEntrega = () => import(/* webpackChunkName: "ass" */ "./views/ass/ModoEntrega.vue");

const MotivosCancelamento = () => import(/* webpackChunkName: "ass" */ "./views/ass/MotivosCancelamento.vue");
const MotivoCancelamento = () => import(/* webpackChunkName: "ass" */ "./views/ass/MotivoCancelamento.vue");

const MotivosSuspensao = () => import(/* webpackChunkName: "ass" */ "./views/ass/MotivosSuspensao.vue");
const MotivoSuspensao = () => import(/* webpackChunkName: "ass" */ "./views/ass/MotivoSuspensao.vue");

const Cobranca = () => import(/* webpackChunkName: "ass" */ "./views/ass/Cobranca.vue");

const Recuperacao = () => import(/* webpackChunkName: "ass" */ "./views/ass/Recuperacao.vue");

const ReclamacoesPadrao = () => import(/* webpackChunkName: "ass" */ "./views/ass/ReclamacoesPadrao.vue");
const ReclamacaoPadrao = () => import(/* webpackChunkName: "ass" */ "./views/ass/ReclamacaoPadrao.vue");

const Origens = () => import(/* webpackChunkName: "ass" */ "./views/ass/Origens.vue");
const Origem = () => import(/* webpackChunkName: "ass" */ "./views/ass/Origem.vue");

const Setores = () => import(/* webpackChunkName: "ass" */ "./views/ass/Setores.vue");
const Setor = () => import(/* webpackChunkName: "ass" */ "./views/ass/Setor.vue");

const PaywallPlanos = () => import(/* webpackChunkName: "ass" */ "./views/ass/PaywallPlanos.vue");
const PaywallPlano = () => import(/* webpackChunkName: "ass" */ "./views/ass/PaywallPlano.vue");

const PaywallAssines = () => import(/* webpackChunkName: "ass" */ "./views/ass/PaywallAssines.vue");
const PaywallAssine = () => import(/* webpackChunkName: "ass" */ "./views/ass/PaywallAssine.vue");

const Reclamacoes = () => import(/* webpackChunkName: "ass" */ "./views/ass/Reclamacoes.vue");

const Contatos = () => import(/* webpackChunkName: "adm" */ "./views/adm/Contatos.vue");

const Produtos = () => import(/* webpackChunkName: "ass" */ "./views/ass/Produtos.vue");
const Produto = () => import(/* webpackChunkName: "ass" */ "./views/ass/Produto.vue");

const Planos = () => import(/* webpackChunkName: "ass" */ "./views/ass/Planos.vue");
const Plano = () => import(/* webpackChunkName: "ass" */ "./views/ass/Plano.vue");

const Promocoes = () => import(/* webpackChunkName: "ass" */ "./views/ass/Promocoes.vue");
const Promocao = () => import(/* webpackChunkName: "ass" */ "./views/ass/Promocao.vue");

const VendaAvulsaTabelas = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaTabelas.vue");
const VendaAvulsaTabela = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaTabela.vue");

const RegrasAjuste = () => import(/* webpackChunkName: "ass" */ "./views/ass/RegrasAjuste.vue");
const RegraAjuste = () => import(/* webpackChunkName: "ass" */ "./views/ass/RegraAjuste.vue");

const Entregadores = () => import(/* webpackChunkName: "ass" */ "./views/ass/Entregadores.vue");
const Entregador = () => import(/* webpackChunkName: "ass" */ "./views/ass/Entregador.vue");

const Bloqueios = () => import(/* webpackChunkName: "ass" */ "./views/ass/Bloqueios.vue");
const Bloqueio = () => import(/* webpackChunkName: "ass" */ "./views/ass/Bloqueio.vue");

const Rotas = () => import(/* webpackChunkName: "ass" */ "./views/ass/Rotas.vue");
const Rota = () => import(/* webpackChunkName: "ass" */ "./views/ass/Rota.vue");

const VendaAvulsaRepartes = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaRepartes.vue");
const VendaAvulsaReparte = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaReparte.vue");
const VendaAvulsaReparteBanca = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaReparteBanca.vue");

const VendaAvulsaFaturamento = () => import(/* webpackChunkName: "ass" */ "./views/ass/VendaAvulsaFaturamento.vue");

const TiposBanca = () => import(/* webpackChunkName: "ass" */ "./views/ass/TiposBanca.vue");
const TipoBanca = () => import(/* webpackChunkName: "ass" */ "./views/ass/TipoBanca.vue");

const RegrasComissionamento = () => import(/* webpackChunkName: "ass" */ "./views/ass/RegrasComissionamento.vue");
const RegraComissionamento = () => import(/* webpackChunkName: "ass" */ "./views/ass/RegraComissionamento.vue");

const RegrasComissionamentoUsuarios = () => import(/* webpackChunkName: "ass" */ "./views/ass/RegrasComissionamentoUsuarios.vue");

const ConfigFechamentoRoteiro = () => import(/* webpackChunkName: "ass" */ "./views/ass/ConfigFechamentoRoteiro.vue");
const ConfigIVC = () => import(/* webpackChunkName: "ass" */ "./views/ass/ConfigIVC.vue");

const MunicipiosIVC = () => import(/* webpackChunkName: "ass" */ "./views/ass/MunicipiosIVC");
const MunicipioIVC = () => import(/* webpackChunkName: "ass" */ "./views/ass/MunicipioIVC.vue");

const Carteira = () => import(/* webpackChunkName: "ass-rel" */ "./views/ass/rel/Carteira.vue");
const Comissionamento = () => import(/* webpackChunkName: "ass-rel" */ "./views/ass/rel/Comissionamento.vue");
const Distribuicao = () => import(/* webpackChunkName: "ass-rel" */ "./views/ass/rel/Distribuicao.vue");
const IVC = () => import(/* webpackChunkName: "ass-rel" */ "./views/ass/rel/IVC.vue");

//* Rotas do Módulo Financeiro
//============================
const DeskTopFIN = () => import(/* webpackChunkName: "fin" */ "./views/fin/Desktop.vue");

const Extratos = () => import(/* webpackChunkName: "fin" */ "./views/fin/Extratos.vue");
const Extrato = () => import(/* webpackChunkName: "fin" */ "./views/fin/Extrato.vue");

const Operacoes = () => import(/* webpackChunkName: "fin" */ "./views/fin/Operacoes.vue");
const Operacao = () => import(/* webpackChunkName: "fin" */ "./views/fin/Operacao.vue");

const Parcelas = () => import(/* webpackChunkName: "fin" */ "./views/fin/Parcelas.vue");
const Parcela = () => import(/* webpackChunkName: "fin" */ "./views/fin/Parcela.vue");

const RemessasRetornos = () => import(/* webpackChunkName: "fin" */ "./views/fin/RemessasRetornos.vue");

const Emails = () => import(/* webpackChunkName: "fin" */ "./views/fin/Emails.vue");

const Transferencias = () => import(/* webpackChunkName: "fin" */ "./views/fin/Transferencias.vue");
const Transferencia = () => import(/* webpackChunkName: "fin" */ "./views/fin/Transferencia.vue");

const Bancos = () => import(/* webpackChunkName: "fin" */ "./views/fin/Bancos.vue");
const Banco = () => import(/* webpackChunkName: "fin" */ "./views/fin/Banco.vue");

const Cedentes = () => import(/* webpackChunkName: "fin" */ "./views/fin/Cedentes.vue");
const Cedente = () => import(/* webpackChunkName: "fin" */ "./views/fin/Cedente.vue");

const CelescBloqueios = () => import(/* webpackChunkName: "fin" */ "./views/fin/CelescBloqueios.vue");
const CelescBloqueio = () => import(/* webpackChunkName: "fin" */ "./views/fin/CelescBloqueio.vue");
const CelescTitulos = () => import(/* webpackChunkName: "fin" */ "./views/fin/CelescTitulos.vue");
const CelescRecepcoes = () => import(/* webpackChunkName: "fin" */ "./views/fin/CelescRecepcoes.vue");
const CelescRemessasRetornos = () => import(/* webpackChunkName: "fin" */ "./views/fin/CelescRemessasRetornos.vue");

const CentrosCusto = () => import(/* webpackChunkName: "fin" */ "./views/fin/CentrosCusto.vue");
const CentroCusto = () => import(/* webpackChunkName: "fin" */ "./views/fin/CentroCusto.vue");

const Contabilistas = () => import(/* webpackChunkName: "fin" */ "./views/fin/Contabilistas.vue");
const Contabilista = () => import(/* webpackChunkName: "fin" */ "./views/fin/Contabilista.vue");

const Contas = () => import(/* webpackChunkName: "fin" */ "./views/fin/Contas.vue");
const Conta = () => import(/* webpackChunkName: "fin" */ "./views/fin/Conta.vue");

const NFe = () => import(/* webpackChunkName: "fin" */ "./views/fin/NFe.vue");
const NFSC = () => import(/* webpackChunkName: "fin" */ "./views/fin/NFSC.vue");
const NFSe = () => import(/* webpackChunkName: "fin" */ "./views/fin/NFSe.vue");
const NFCom = () => import(/* webpackChunkName: "fin" */ "./views/fin/NFCom.vue");

const FechamentoNFSC = () => import(/* webpackChunkName: "fin" */ "./views/fin/FechamentoNFSC.vue");
const FechamentoSPED = () => import(/* webpackChunkName: "fin" */ "./views/fin/FechamentoSPED.vue");

const ConfigNFe = () => import(/* webpackChunkName: "fin" */ "./views/fin/ConfigNFe.vue");
const ConfigNFSC = () => import(/* webpackChunkName: "fin" */ "./views/fin/ConfigNFSC.vue");
const ConfigNFSe = () => import(/* webpackChunkName: "fin" */ "./views/fin/ConfigNFSe.vue");
const ConfigNFCom = () => import(/* webpackChunkName: "fin" */ "./views/fin/ConfigNFCom.vue");

const Apresentacao = () => import(/* webpackChunkName: "fin-rel" */ "./views/fin/rel/Apresentacao.vue");
const Balancete = () => import(/* webpackChunkName: "fin-rel" */ "./views/fin/rel/Balancete.vue");
const ClienteFornecedor = () => import(/* webpackChunkName: "fin-rel" */ "./views/fin/rel/ClienteFornecedor.vue");
const Conciliacao = () => import(/* webpackChunkName: "fin-rel" */ "./views/fin/rel/Conciliacao.vue");
const MotivosParcela = () => import(/* webpackChunkName: "fin" */ "./views/fin/MotivosParcela.vue");
const MotivoParcela = () => import(/* webpackChunkName: "fin" */ "./views/fin/MotivoParcela.vue");
const FinOrigens = () => import(/* webpackChunkName: "fin" */ "./views/fin/Origens.vue");
const FinOrigem = () => import(/* webpackChunkName: "fin" */ "./views/fin/Origem.vue");

const FluxoCaixa = () => import(/* webpackChunkName: "fin" */ "./views/fin/FluxoCaixa.vue");

//* Rotas do Módulo EDT
//============================
const Artigos = () => import(/* webpackChunkName: "edt" */ "./views/edt/Artigos.vue");
const Artigo = () => import(/* webpackChunkName: "edt" */ "./views/edt/Artigo.vue");
const Editoria = () => import(/* webpackChunkName: "edt" */ "./views/edt/Editoria.vue");
const Editorias = () => import(/* webpackChunkName: "edt" */ "./views/edt/Editorias.vue");
const AcessosEditorias = () => import(/* webpackChunkName: "edt" */ "./views/edt/AcessosEditorias.vue");

//* Rotas do Módulo ARQ
//============================
const Arqmidia = () => import(/* webpackChunkName: "arq" */ "./views/arq/Desktop.vue");
const Arqcortes = () => import(/* webpackChunkName: "arq" */ "./views/arq/Cortes.vue");

//* Rotas do Módulo FLIP
//============================
const DeskTopFLIP = () => import(/* webpackChunkName: "flip" */ "./views/flip/Desktop.vue");

const Edicoes = () => import(/* webpackChunkName: "flip" */ "./views/flip/Edicoes.vue");
const Edicao = () => import(/* webpackChunkName: "flip" */ "./views/flip/Edicao.vue");
const Flip = () => import(/* webpackChunkName: "flip" */ "./views/flip/Flip.vue");

Vue.use(Router);

const pushOriginal = Router.prototype.push;
Router.prototype.push = function push(location, onComplete, onAbort) {
  if (onComplete || onAbort) {
    return pushOriginal.call(this, location, onComplete, onAbort);
  }
  return pushOriginal.call(this, location).catch((err) => {
    if (err && (err.name == "NavigationDuplicated" || /Avoided redundant navigation to current location|Navigating to current location/.test(err.message || ""))) {
      return err;
    }
    throw err;
  });
};

const replaceOriginal = Router.prototype.replace;
Router.prototype.replace = function replace(location, onComplete, onAbort) {
  if (onComplete || onAbort) {
    return replaceOriginal.call(this, location, onComplete, onAbort);
  }
  return replaceOriginal.call(this, location).catch((err) => {
    if (err && (err.name == "NavigationDuplicated" || /Avoided redundant navigation to current location|Navigating to current location/.test(err.message || ""))) {
      return err;
    }
    throw err;
  });
};

const router = new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH ? process.env.VUE_APP_BASE_PATH + "/" : "/",
  routes: [
    {
      path: "/",
      component: Dashboard
    },
    {
      path: "/login",
      component: Login,
      meta: {
        publico: true,
        somenteDeslogado: true
      }
    },
    {
      path: "/acesso-negado",
      component: AcessoNegado
    },

    //* Rotas do Módulo Administrativo
    //================================
    {
      path: "/administrativo/desktop",
      component: DeskTopADM
    },

    {
      path: "/administrativo/paises",
      component: Paises
    },
    {
      path: "/administrativo/pais",
      component: Pais
    },
    {
      path: "/administrativo/pais/:id",
      component: Pais
    },

    {
      path: "/administrativo/ufs",
      component: UFs
    },
    {
      path: "/administrativo/uf",
      component: UF
    },
    {
      path: "/administrativo/uf/:id",
      component: UF
    },

    {
      path: "/administrativo/municipios",
      component: Municipios
    },
    {
      path: "/administrativo/municipio",
      component: Municipio
    },
    {
      path: "/administrativo/municipio/:id",
      component: Municipio
    },

    {
      path: "/administrativo/redes",
      component: Redes
    },
    {
      path: "/administrativo/rede",
      component: Rede
    },
    {
      path: "/administrativo/rede/:id",
      component: Rede
    },

    {
      path: "/administrativo/grupos",
      component: Grupos
    },
    {
      path: "/administrativo/grupo",
      component: Grupo
    },
    {
      path: "/administrativo/grupo/:id",
      component: Grupo
    },

    {
      path: "/administrativo/sites",
      component: Sites
    },
    {
      path: "/administrativo/site",
      component: Site
    },
    {
      path: "/administrativo/site/:id",
      component: Site
    },

    {
      path: "/administrativo/perfis",
      component: Perfis
    },
    {
      path: "/administrativo/perfil",
      component: Perfil
    },
    {
      path: "/administrativo/perfil/:id",
      component: Perfil
    },

    {
      path: "/administrativo/usuarios",
      component: Usuarios
    },
    {
      path: "/administrativo/usuario",
      component: Usuario
    },
    {
      path: "/administrativo/usuario/:id",
      component: Usuario
    },

    {
      path: "/administrativo/tipos-logradouro",
      component: TiposLogradouro
    },
    {
      path: "/administrativo/tipo-logradouro",
      component: TipoLogradouro
    },
    {
      path: "/administrativo/tipo-logradouro/:id",
      component: TipoLogradouro
    },

    {
      path: "/administrativo/ceps",
      component: CEPs
    },
    {
      path: "/administrativo/cep",
      component: CEP
    },
    {
      path: "/administrativo/cep/:id",
      component: CEP
    },

    {
      path: "/administrativo/acervo-ceps",
      component: AcervoCEPs
    },
    // {
    //   path: "/administrativo/acervo-cep/:id",
    //   component: AcervoCEP
    // },

    {
      path: "/administrativo/acervo-clientes",
      component: AcervoClientes
    },
    // {
    //   path: "/administrativo/acervo-cliente/:id",
    //   component: AcervoCliente
    // },

    {
      path: "/administrativo/agentes",
      component: Clientes
    },
    {
      path: "/administrativo/agente",
      component: Cliente
    },
    {
      path: "/administrativo/agente/:id",
      component: Cliente
    },

    {
      path: "/administrativo/configs-emails",
      component: ConfigsEmails
    },
    {
      path: "/administrativo/config-email",
      component: ConfigEmail
    },
    {
      path: "/administrativo/config-email/:id",
      component: ConfigEmail
    },

    {
      path: "/administrativo/feriados",
      component: Feriados
    },
    {
      path: "/administrativo/feriado",
      component: Feriado
    },
    {
      path: "/administrativo/feriado/:id",
      component: Feriado
    },

    {
      path: "/administrativo/formas-pagamento",
      component: FormasPagamento
    },
    {
      path: "/administrativo/forma-pagamento",
      component: FormaPagamento
    },
    {
      path: "/administrativo/forma-pagamento/:id",
      component: FormaPagamento
    },

    {
      path: "/administrativo/motivos-contato",
      component: MotivosContato
    },
    {
      path: "/administrativo/motivo-contato",
      component: MotivoContato
    },
    {
      path: "/administrativo/motivo-contato/:id",
      component: MotivoContato
    },

    {
      path: "/administrativo/ramos-atividade",
      component: RamosAtividade
    },
    {
      path: "/administrativo/ramo-atividade",
      component: RamoAtividade
    },
    {
      path: "/administrativo/ramo-atividade/:id",
      component: RamoAtividade
    },

    {
      path: "/administrativo/radios",
      component: Programacoes
    },
    {
      path: "/administrativo/radio",
      component: Programacao
    },
    {
      path: "/administrativo/radio/:id",
      component: Programacao
    },

    {
      path: "/administrativo/tvs",
      component: Programacoes
    },
    {
      path: "/administrativo/tv",
      component: Programacao
    },
    {
      path: "/administrativo/tv/:id",
      component: Programacao
    },

    {
      path: "/administrativo/mensagens",
      component: Mensagens
    },

    {
      path: "/administrativo/editorias",
      component: Editorias
    },
    {
      path: "/administrativo/editoria/:mae/:id",
      component: Editoria
    },
    {
      path: "/administrativo/editoria/:mae",
      component: Editoria
    },

    {
      path: "/administrativo/acessos-editorias",
      component: AcessosEditorias
    },

    //* Rotas do Módulo Assinaturas
    //=============================
    {
      path: "/assinaturas/desktop",
      component: DeskTopASS
    },
    {
      path: "/assinaturas/assinantes",
      component: Clientes
    },
    {
      path: "/assinaturas/assinante",
      component: Cliente
    },
    {
      path: "/assinaturas/assinante/:id",
      component: Cliente
    },

    {
      path: "/assinaturas/assinaturas",
      component: Assinaturas
    },
    //* Captação de nova assinatura
    {
      path: "/assinaturas/assinatura",
      component: AssinaturaCaptacao
    },
    //* Edição da renovação (se ainda não iniciou, tudo exceto dataFim; caso já tenha iniciado: autorização, parcelas e encerrar ou agendar encerramento criando uma renovação futura)
    {
      path: "/assinaturas/assinatura/:idAssinatura/:idRenovacao",
      component: AssinaturaCaptacao
    },
    //* Edição da assinatura como um todo
    {
      path: "/assinaturas/assinatura/:id",
      component: AssinaturaEdicao
    },

    {
      path: "/assinaturas/roteiro-ordem",
      component: RoteiroOrdem
    },

    {
      path: "/assinaturas/roteiro-entrega",
      component: RoteiroEntrega
    },
    {
      path: "/assinaturas/venda-avulsa-roteiro-entrega",
      component: RoteiroEntrega
    },
    {
      path: "/assinaturas/roteiro-historico",
      component: HistoricoRoteiro
    },

    {
      path: "/assinaturas/bancas",
      component: Clientes
    },
    {
      path: "/assinaturas/banca",
      component: Cliente
    },
    {
      path: "/assinaturas/banca/:id",
      component: Cliente
    },

    {
      path: "/assinaturas/etapas-cobranca",
      component: EtapasCobranca
    },
    {
      path: "/assinaturas/etapa-cobranca",
      component: EtapaCobranca
    },
    {
      path: "/assinaturas/etapa-cobranca/:id",
      component: EtapaCobranca
    },
    {
      path: "/assinaturas/etapa-cobranca-grupo",
      component: EtapaCobrancaGrupo
    },
    {
      path: "/assinaturas/etapa-cobranca-grupo/:id",
      component: EtapaCobrancaGrupo
    },

    {
      path: "/assinaturas/modalidades",
      component: Modalidades
    },
    {
      path: "/assinaturas/modalidade",
      component: Modalidade
    },
    {
      path: "/assinaturas/modalidade/:id",
      component: Modalidade
    },

    {
      path: "/assinaturas/modos-entrega",
      component: ModosEntrega
    },
    {
      path: "/assinaturas/modo-entrega",
      component: ModoEntrega
    },
    {
      path: "/assinaturas/modo-entrega/:id",
      component: ModoEntrega
    },

    {
      path: "/assinaturas/motivos-cancelamento",
      component: MotivosCancelamento
    },
    {
      path: "/assinaturas/motivo-cancelamento",
      component: MotivoCancelamento
    },
    {
      path: "/assinaturas/motivo-cancelamento/:id",
      component: MotivoCancelamento
    },

    {
      path: "/assinaturas/motivos-suspensao",
      component: MotivosSuspensao
    },
    {
      path: "/assinaturas/motivo-suspensao",
      component: MotivoSuspensao
    },
    {
      path: "/assinaturas/motivo-suspensao/:id",
      component: MotivoSuspensao
    },

    {
      path: "/assinaturas/cobranca",
      component: Cobranca
    },

    {
      path: "/assinaturas/recuperacao",
      component: Recuperacao
    },

    {
      path: "/assinaturas/clube-assinante",
      component: ClubeAssinante
    },

    {
      path: "/assinaturas/reclamacoes",
      component: Reclamacoes
    },

    {
      path: "/assinaturas/contatos",
      component: Contatos
    },

    {
      path: "/assinaturas/cupons-promocoes",
      component: CuponsPromocoes
    },

    {
      path: "/assinaturas/reclamacoes-padrao",
      component: ReclamacoesPadrao
    },
    {
      path: "/assinaturas/reclamacao-padrao",
      component: ReclamacaoPadrao
    },
    {
      path: "/assinaturas/reclamacao-padrao/:id",
      component: ReclamacaoPadrao
    },

    {
      path: "/assinaturas/setores",
      component: Setores
    },
    {
      path: "/assinaturas/setor",
      component: Setor
    },
    {
      path: "/assinaturas/setor/:id",
      component: Setor
    },

    {
      path: "/assinaturas/origens",
      component: Origens
    },
    {
      path: "/assinaturas/origem",
      component: Origem
    },
    {
      path: "/assinaturas/origem/:id",
      component: Origem
    },

    {
      path: "/assinaturas/paywall/planos",
      component: PaywallPlanos
    },
    {
      path: "/assinaturas/paywall/plano",
      component: PaywallPlano
    },
    {
      path: "/assinaturas/paywall/plano/:id",
      component: PaywallPlano
    },

    {
      path: "/assinaturas/paywall/assines",
      component: PaywallAssines
    },
    {
      path: "/assinaturas/paywall/assine",
      component: PaywallAssine
    },
    {
      path: "/assinaturas/paywall/assine/:id",
      component: PaywallAssine
    },

    {
      path: "/assinaturas/produtos",
      component: Produtos
    },
    {
      path: "/assinaturas/produto",
      component: Produto
    },
    {
      path: "/assinaturas/produto/:id",
      component: Produto
    },

    {
      path: "/assinaturas/planos",
      component: Planos
    },
    {
      path: "/assinaturas/plano",
      component: Plano
    },
    {
      path: "/assinaturas/plano/:id",
      component: Plano
    },

    {
      path: "/assinaturas/promocoes",
      component: Promocoes
    },
    {
      path: "/assinaturas/promocao",
      component: Promocao
    },
    {
      path: "/assinaturas/promocao/:id",
      component: Promocao
    },

    {
      path: "/assinaturas/venda-avulsa-tabelas",
      component: VendaAvulsaTabelas
    },
    {
      path: "/assinaturas/venda-avulsa-tabela",
      component: VendaAvulsaTabela
    },
    {
      path: "/assinaturas/venda-avulsa-tabela/:id",
      component: VendaAvulsaTabela
    },

    {
      path: "/assinaturas/venda-avulsa-repartes",
      component: VendaAvulsaRepartes
    },
    {
      path: "/assinaturas/venda-avulsa-reparte",
      component: VendaAvulsaReparte
    },
    {
      path: "/assinaturas/venda-avulsa-reparte/:id",
      component: VendaAvulsaReparte
    },

    {
      path: "/assinaturas/venda-avulsa-reparte-banca/:id",
      component: VendaAvulsaReparteBanca
    },

    {
      path: "/assinaturas/venda-avulsa-faturamento",
      component: VendaAvulsaFaturamento
    },

    {
      path: "/assinaturas/regras-ajuste",
      component: RegrasAjuste
    },
    {
      path: "/assinaturas/regra-ajuste",
      component: RegraAjuste
    },
    {
      path: "/assinaturas/regra-ajuste/:id",
      component: RegraAjuste
    },

    {
      path: "/assinaturas/entregadores",
      component: Entregadores
    },
    {
      path: "/assinaturas/entregador",
      component: Entregador
    },
    {
      path: "/assinaturas/entregador/:id",
      component: Entregador
    },

    {
      path: "/assinaturas/bloqueios",
      component: Bloqueios
    },
    {
      path: "/assinaturas/bloqueio",
      component: Bloqueio
    },
    {
      path: "/assinaturas/bloqueio/:id",
      component: Bloqueio
    },

    {
      path: "/assinaturas/rotas",
      component: Rotas
    },
    {
      path: "/assinaturas/rota",
      component: Rota
    },
    {
      path: "/assinaturas/rota/:id",
      component: Rota
    },
    {
      path: "/assinaturas/tipos-logradouro",
      component: TiposLogradouro
    },
    {
      path: "/assinaturas/tipo-logradouro",
      component: TipoLogradouro
    },
    {
      path: "/assinaturas/tipo-logradouro/:id",
      component: TipoLogradouro
    },

    {
      path: "/assinaturas/ceps",
      component: CEPs
    },
    {
      path: "/assinaturas/cep",
      component: CEP
    },
    {
      path: "/assinaturas/cep/:id",
      component: CEP
    },

    {
      path: "/assinaturas/tipos-banca",
      component: TiposBanca
    },
    {
      path: "/assinaturas/tipo-banca",
      component: TipoBanca
    },
    {
      path: "/assinaturas/tipo-banca/:id",
      component: TipoBanca
    },

    {
      path: "/assinaturas/regras-comissionamento",
      component: RegrasComissionamento
    },
    {
      path: "/assinaturas/regra-comissionamento",
      component: RegraComissionamento
    },
    {
      path: "/assinaturas/regra-comissionamento/:id",
      component: RegraComissionamento
    },

    // {
    //   path: "/assinaturas/regras-comissionamento-usuarios",
    //   component: RegrasComissionamentoUsuarios
    // },

    {
      path: "/assinaturas/config-fechamento-roteiro",
      component: ConfigFechamentoRoteiro
    },
    {
      path: "/assinaturas/config-ivc",
      component: ConfigIVC
    },

    {
      path: "/assinaturas/municipios-ivc",
      component: MunicipiosIVC
    },
    {
      path: "/assinaturas/municipio-ivc",
      component: MunicipioIVC
    },

    {
      path: "/assinaturas/relatorios/carteira",
      component: Carteira
    },
    {
      path: "/assinaturas/relatorios/comissionamento",
      component: Comissionamento
    },
    {
      path: "/assinaturas/relatorios/distribuicao",
      component: Distribuicao
    },
    {
      path: "/assinaturas/relatorios/ivc",
      component: IVC
    },

    //* Rotas do Módulo Comercial
    //=============================
    {
      path: "/comercial/desktop",
      component: DeskTopCOM
    },

    {
      path: "/comercial/anunciantes",
      component: Clientes
    },
    {
      path: "/comercial/anunciante",
      component: Cliente
    },
    {
      path: "/comercial/anunciante/:id",
      component: Cliente
    },

    {
      path: "/comercial/pacotes",
      component: Pacotes
    },
    {
      path: "/comercial/pacote",
      component: Pacote
    },
    {
      path: "/comercial/pacote/:id",
      component: Pacote
    },

    {
      path: "/comercial/anuncios",
      component: Anuncios
    },
    {
      path: "/comercial/anuncio",
      component: Anuncio
    },
    {
      path: "/comercial/anuncio/:id",
      component: Anuncio
    },

    {
      path: "/comercial/cobranca",
      component: Cobranca
    },

    {
      path: "/comercial/contatos",
      component: Contatos
    },

    {
      path: "/comercial/produtos",
      component: ProdutosComercial
    },
    {
      path: "/comercial/produto",
      component: ProdutoComercial
    },
    {
      path: "/comercial/produto/:id",
      component: ProdutoComercial
    },

    {
      path: "/comercial/cadernos",
      component: Cadernos
    },
    {
      path: "/comercial/caderno",
      component: Caderno
    },
    {
      path: "/comercial/caderno/:id",
      component: Caderno
    },

    {
      path: "/comercial/condicoes-especiais",
      component: CondicoesEspeciais
    },
    {
      path: "/comercial/condicao-especial",
      component: CondicaoEspecial
    },
    {
      path: "/comercial/condicao-especial/:id",
      component: CondicaoEspecial
    },

    {
      path: "/comercial/categorias",
      component: Categorias
    },
    {
      path: "/comercial/categoria",
      component: Categoria
    },
    {
      path: "/comercial/categoria/:id",
      component: Categoria
    },

    {
      path: "/comercial/origens",
      component: ComOrigens
    },
    {
      path: "/comercial/origem",
      component: ComOrigem
    },
    {
      path: "/comercial/origem/:id",
      component: ComOrigem
    },

    {
      path: "/comercial/regras-ajuste",
      component: RegrasAjuste
    },
    {
      path: "/comercial/regra-ajuste",
      component: RegraAjuste
    },
    {
      path: "/comercial/regra-ajuste/:id",
      component: RegraAjuste
    },

    {
      path: "/comercial/formatos",
      component: Formatos
    },
    {
      path: "/comercial/formato",
      component: Formato
    },
    {
      path: "/comercial/formato/:id",
      component: Formato
    },

    {
      path: "/comercial/determinacoes",
      component: Determinacoes
    },
    {
      path: "/comercial/determinacao",
      component: Determinacao
    },
    {
      path: "/comercial/determinacao/:id",
      component: Determinacao
    },

    {
      path: "/comercial/colocacoes",
      component: Colocacoes
    },
    {
      path: "/comercial/colocacao",
      component: Colocacao
    },
    {
      path: "/comercial/colocacao/:id",
      component: Colocacao
    },

    {
      path: "/comercial/secoes",
      component: Secoes
    },
    {
      path: "/comercial/secao/:mae",
      component: Secao
    },
    {
      path: "/comercial/secao/:mae/:id",
      component: Secao
    },

    {
      path: "/comercial/anuncio-tabelas",
      component: TabelasPreco
    },
    {
      path: "/comercial/anuncio-tabela",
      component: TabelaPreco
    },
    {
      path: "/comercial/anuncio-tabela/:id",
      component: TabelaPreco
    },

    {
      path: "/comercial/textos",
      component: Textos
    },
    {
      path: "/comercial/texto",
      component: Texto
    },
    {
      path: "/comercial/texto/:id",
      component: Texto
    },

    // {
    //   path: "/comercial/diagramas",
    //   component: Diagramas
    // },
    // {
    //   path: "/comercial/diagrama",
    //   component: Diagrama
    // },
    // {
    //   path: "/comercial/diagrama/:id",
    //   component: Diagrama
    // },

    {
      path: "/comercial/etapas-cobranca",
      component: EtapasCobranca
    },
    {
      path: "/comercial/etapa-cobranca",
      component: EtapaCobranca
    },
    {
      path: "/comercial/etapa-cobranca/:id",
      component: EtapaCobranca
    },
    {
      path: "/comercial/etapa-cobranca-grupo",
      component: EtapaCobrancaGrupo
    },
    {
      path: "/comercial/etapa-cobranca-grupo/:id",
      component: EtapaCobrancaGrupo
    },

    //* Rotas do Módulo Financeiro
    //============================
    {
      path: "/financeiro/desktop",
      component: DeskTopFIN
    },

    {
      path: "/financeiro/clientes",
      component: Clientes
    },
    {
      path: "/financeiro/cliente",
      component: Cliente
    },
    {
      path: "/financeiro/cliente/:id",
      component: Cliente
    },

    {
      path: "/financeiro/fornecedores",
      component: Clientes
    },
    {
      path: "/financeiro/fornecedor",
      component: Cliente
    },
    {
      path: "/financeiro/fornecedor/:id",
      component: Cliente
    },

    {
      path: "/financeiro/extratos",
      component: Extratos
    },
    {
      path: "/financeiro/extrato/:id",
      component: Extrato
    },

    {
      path: "/financeiro/fluxo-caixa",
      component: FluxoCaixa
    },

    {
      path: "/financeiro/operacoes/receber",
      component: Operacoes
    },
    {
      path: "/financeiro/operacao/receber",
      component: Operacao
    },
    {
      path: "/financeiro/operacao/receber/:id",
      component: Operacao
    },

    {
      path: "/financeiro/parcelas/receber",
      component: Parcelas
    },
    {
      path: "/financeiro/parcela/receber/:id",
      component: Parcela
    },

    {
      path: "/financeiro/remessas/receber",
      component: RemessasRetornos
    },

    {
      path: "/financeiro/retornos/receber",
      component: RemessasRetornos
    },

    {
      path: "/financeiro/operacoes/pagar",
      component: Operacoes
    },
    {
      path: "/financeiro/operacao/pagar",
      component: Operacao
    },
    {
      path: "/financeiro/operacao/pagar/:id",
      component: Operacao
    },

    {
      path: "/financeiro/parcelas/pagar",
      component: Parcelas
    },
    {
      path: "/financeiro/parcela/pagar/:id",
      component: Parcela
    },

    {
      path: "/financeiro/remessas/pagar",
      component: RemessasRetornos
    },

    {
      path: "/financeiro/retornos/pagar",
      component: RemessasRetornos
    },

    {
      path: "/financeiro/emails",
      component: Emails
    },

    {
      path: "/financeiro/bancos",
      component: Bancos
    },
    {
      path: "/financeiro/banco",
      component: Banco
    },
    {
      path: "/financeiro/banco/:id",
      component: Banco
    },

    {
      path: "/financeiro/cedentes",
      component: Cedentes
    },
    {
      path: "/financeiro/cedente",
      component: Cedente
    },
    {
      path: "/financeiro/cedente/:id",
      component: Cedente
    },

    {
      path: "/financeiro/celesc-titulos",
      component: CelescTitulos
    },
    {
      path: "/financeiro/celesc-bloqueios",
      component: CelescBloqueios
    },
    {
      path: "/financeiro/celesc-bloqueio",
      component: CelescBloqueio
    },
    {
      path: "/financeiro/celesc-bloqueio/:id",
      component: CelescBloqueio
    },
    {
      path: "/financeiro/celesc-recepcoes",
      component: CelescRecepcoes
    },
    {
      path: "/financeiro/celesc-remessas",
      component: CelescRemessasRetornos
    },

    {
      path: "/financeiro/celesc-retornos",
      component: CelescRemessasRetornos
    },

    {
      path: "/financeiro/transferencias",
      component: Transferencias
    },
    {
      path: "/financeiro/transferencia",
      component: Transferencia
    },
    {
      path: "/financeiro/transferencia/:id",
      component: Transferencia
    },

    {
      path: "/financeiro/centros-custo",
      component: CentrosCusto
    },
    {
      path: "/financeiro/centro-custo",
      component: CentroCusto
    },
    {
      path: "/financeiro/centro-custo/:id",
      component: CentroCusto
    },

    {
      path: "/financeiro/contabilistas",
      component: Contabilistas
    },
    {
      path: "/financeiro/contabilista",
      component: Contabilista
    },
    {
      path: "/financeiro/contabilista/:id",
      component: Contabilista
    },

    {
      path: "/financeiro/contas/:grupo",
      component: Contas
    },
    {
      path: "/financeiro/conta/:grupo/:mae",
      component: Conta
    },
    {
      path: "/financeiro/conta/:grupo/:mae/:id",
      component: Conta
    },

    {
      path: "/financeiro/nfe",
      component: NFe
    },
    {
      path: "/financeiro/nfsc",
      component: NFSC
    },
    {
      path: "/financeiro/nfse",
      component: NFSe
    },
    {
      path: "/financeiro/nfcom",
      component: NFCom
    },

    {
      path: "/financeiro/fechamento/nfsc",
      component: FechamentoNFSC
    },

    {
      path: "/financeiro/fechamento/sped",
      component: FechamentoSPED
    },

    {
      path: "/financeiro/config-nfe",
      component: ConfigNFe
    },
    {
      path: "/financeiro/config-nfsc",
      component: ConfigNFSC
    },
    {
      path: "/financeiro/config-nfse",
      component: ConfigNFSe
    },
    {
      path: "/financeiro/config-nfcom",
      component: ConfigNFCom
    },

    {
      path: "/financeiro/relatorios/apresentacao",
      component: Apresentacao
    },
    {
      path: "/financeiro/relatorios/balancete",
      component: Balancete
    },
    {
      path: "/financeiro/relatorios/cliente-fornecedor",
      component: ClienteFornecedor
    },
    {
      path: "/financeiro/relatorios/conciliacao",
      component: Conciliacao
    },

    {
      path: "/financeiro/cobranca",
      component: Cobranca
    },

    {
      path: "/financeiro/contatos",
      component: Contatos
    },

    {
      path: "/financeiro/etapas-cobranca",
      component: EtapasCobranca
    },
    {
      path: "/financeiro/etapa-cobranca",
      component: EtapaCobranca
    },
    {
      path: "/financeiro/etapa-cobranca/:id",
      component: EtapaCobranca
    },
    {
      path: "/financeiro/etapa-cobranca-grupo",
      component: EtapaCobrancaGrupo
    },
    {
      path: "/financeiro/etapa-cobranca-grupo/:id",
      component: EtapaCobrancaGrupo
    },

    {
      path: "/financeiro/motivos-parcela",
      component: MotivosParcela
    },
    {
      path: "/financeiro/motivo-parcela",
      component: MotivoParcela
    },
    {
      path: "/financeiro/motivo-parcela/:id",
      component: MotivoParcela
    },
    {
      path: "/financeiro/origens",
      component: FinOrigens
    },
    {
      path: "/financeiro/origem",
      component: FinOrigem
    },
    {
      path: "/financeiro/origem/:id",
      component: FinOrigem
    },

    //* Rotas do Módulo Editorial
    //=============================
    // {
    //   path: "/editorial/estilos",
    //   component: Estilos
    // },
    {
      path: "/editorial/artigos",
      component: Artigos
    },
    {
      path: "/editorial/artigo/:idEditoria/:id/:idConteudo/:idModelos",
      component: Artigo
    },
    {
      path: "/editorial/artigo",
      component: Artigo
    },

    //* Rotas do Módulo Flip
    //======================
    {
      path: "/flip/desktop",
      component: DeskTopFLIP
    },
    {
      path: "/flip/edicoes",
      component: Edicoes
    },
    {
      path: "/flip/edicao",
      component: Edicao
    },
    {
      path: "/flip/edicao/:id",
      component: Edicao
    },
    {
      path: "/flip/flip",
      component: Flip
    },

    //* Rotas do Módulo Arqmidia
    //======================
    {
      path: "/arq/desktop",
      component: Arqmidia
    },
    {
      path: "/arq/cortes",
      component: Arqcortes
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  const publico = to.matched.some((record) => record.meta.publico);
  const logout = to.matched.some((record) => record.meta.somenteDeslogado);
  const logado = VueCookies.get("token") ? true : false;

  if (!publico && !logado) {
    return next({
      path: "/login",
      query: to.fullPath != "/" ? { redirect: to.fullPath } : ""
    });
  }

  if (logado && logout) {
    return next("/");
  }

  //* Se a sessão está marcada como "senha pendente" (senha fraca detectada
  //* no último login), bloqueia qualquer rota interna e força o usuário a
  //* voltar para a tela de login, onde o diálogo de troca será apresentado.
  if (logado && VueCookies.get("senhaPendente") == "true" && to.path !== "/login") {
    //* Remove o token para garantir que o usuário precise logar novamente
    //* (a senha em texto puro é necessária para o PUT adm/usuario/senha).
    VueCookies.remove("token");
    return next({ path: "/login" });
  }

  store.commit("UPDATE_MENU", to);

  next();
});

export default router;
